import type { LevelTableColumn } from 'redesign';
import { Tooltip, Typography } from '@mui/material';
import { ContextMenuButton, TableCell, TableHeader } from 'redesign';
import { TFunctionNonStrict } from 'i18next';
import { ArchiveTableColumnDefinition, ArchiveTableOptions, CellProp } from './archive-table.types';
import { getCheckoutsColumnDefinitionBase } from '../../../../shared/columns/get-checkouts-column-definition-base';
import {
  CheckoutsColumnBase,
  CheckoutsTableOptions,
} from '../../../../shared/columns/get-checkouts-column-definition-base.types';
import { WorkedTimeCell } from '../components/worked-time-cell';

export const getArchiveColumnDefinition: (
  allowExpenses: boolean,
  t: TFunctionNonStrict<'ogp-screen-specific', undefined>,
  hideLimitedCompanyShiftFields?: boolean
) => LevelTableColumn<ArchiveTableColumnDefinition, ArchiveTableOptions>[] = (
  allowExpenses,
  t,
  hideLimitedCompanyShiftFields = false
) => {
  const status: LevelTableColumn<ArchiveTableColumnDefinition, ArchiveTableOptions> = {
    Header: () => (
      <TableHeader>
        {t('archive.shifts.table_headers.status', { ns: 'ogp-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'status',
    Cell: StatusCell,
  };

  const worked: LevelTableColumn<CheckoutsColumnBase, CheckoutsTableOptions> = {
    Header: () => (
      <>
        <TableHeader>
          {t('archive.shifts.table_headers.working_hours', { ns: 'ogp-screen-specific' })}
        </TableHeader>
        <TableHeader>
          {t('archive.shifts.table_headers.time_worked', { ns: 'ogp-screen-specific' })}
        </TableHeader>
      </>
    ),
    accessor: 'workedTime',
    Cell: WorkedTimeCell,
  };

  const actions: LevelTableColumn<ArchiveTableColumnDefinition, ArchiveTableOptions> = {
    accessor: 'actions',
    Header: '',
    Cell: ActionCell,
  };

  const { expense, fw, job, date, scheduled, timeDeviationAndBreak, branchOffice, department } =
    getCheckoutsColumnDefinitionBase(allowExpenses, t);

  return [
    fw,
    ...(hideLimitedCompanyShiftFields ? [] : [job, branchOffice, department]),
    date,
    scheduled,
    worked,
    timeDeviationAndBreak,
    expense,
    status,
    actions,
  ];
};

const StatusCell = (cell: CellProp<'status'>) => {
  if (cell.value.state === 'noShow') {
    return (
      <Tooltip title={cell.value.noShowReason.longDescription}>
        <Typography variant="body1" color="secondary">
          No-show
        </Typography>
      </Tooltip>
    );
  }
  if (cell.value.state === 'counterOffer') {
    return <TableCell>Tegenvoorstel</TableCell>;
  }
  if (cell.value.state === 'cancelationOfferSettled') {
    return <TableCell>Annuleringsaanbod</TableCell>;
  }
  return <TableCell>Akkoord</TableCell>;
};

const ActionCell = (cell: CellProp<'actions'>) => {
  const actions = cell.getRowActions(cell.value);

  return (
    <ContextMenuButton
      menuId={`claimant-actions-menu-${cell.value.worker.workerId}`}
      disabled={actions.length === 0}
    >
      {actions}
    </ContextMenuButton>
  );
};
